// extracted by mini-css-extract-plugin
module.exports = {"additionalInfosList":"style_additionalInfosList__Ro5Y9","selectedType":"style_selectedType__J1XUs","options":"style_options__3dzDI","option":"style_option__1B8FI"};